import script from "./userSexAge.vue?vue&type=script&setup=true&lang=js"
export * from "./userSexAge.vue?vue&type=script&setup=true&lang=js"

import "./userSexAge.vue?vue&type=style&index=0&id=296447be&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\北京仟维科技有限公司\\后台管理\\可视化\\admin-vue-data-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296447be"]])

export default __exports__